import React, { FC, useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@radix-ui/themes";
import { Button } from "@/components/button";

interface SearchFormProps {
  initialValue?: string;
  onSearch: (query: string) => void;
}

export const CapturedWebsitesSearchForm: FC<SearchFormProps> = ({
  initialValue = "",
  onSearch,
}) => {
  const [inputValue, setInputValue] = useState<string>(initialValue);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(inputValue.trim());
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextFieldContainer
        placeholder="Search captured websites..."
        value={inputValue}
        onChange={event => setInputValue(event.currentTarget.value)}
        maxLength={100}
        aria-label="Search captured websites"
        style={{ flex: 1 }}
      />
      <Button type="submit">Search</Button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const TextFieldContainer = styled(TextField.Root)`
  max-width: 360px;
`;
